import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ViewBasePage } from '@shared/pages';
import { EventsService, FirebaseFunctionsService, UtilsService, UxHelperService } from '@shared/services';
import { Constants } from '@shared/models';
import type { TCustomer } from '@shared/models';
// import { count } from 'console';

@Component({
    'selector': 'app-testSms',
    'templateUrl': './testSms.page.html',
    'styleUrls': ['./testSms.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class TestSmsPage extends ViewBasePage implements OnInit {
    public vm: any = {};

    // private utilsService: UtilsService,
    constructor(injector: Injector) {
        super(injector);

        // private uxHelperService: UxHelperService, 
        // private eventsService: EventsService) {
    }

    // public override ngOnInit() {
    // }

    public async onSendTextClick() {
        const customers: TCustomer[] = [];

        const temp = this.utilsService.unformatPhoneNumber(this.vm.cellPhones);
        const cellNumbers: any = temp.split(',');

        cellNumbers.forEach((cellNumber: string) => {
            const cellPhoneUnformatted = this.utilsService.unformatPhoneNumber(cellNumber);
            const customer: TCustomer = {
                'customerName': 'Michael',
                'cellPhone': cellPhoneUnformatted,
                'uid': null,
                shuttleDates: []
            };
            customers.push(customer);
        });
        // console.log('customers', customers);

        try {
            await this.uxHelperService.showSpinner('Sending text messages.');
            const data = {
                customers: customers,
                accountNumber: this.sessionService.getAccountNumber(),
                smsType: 'smsTest',
                countryCode: '1',
                debug: this.vm.textMessage
            };
            // console.log('data', data);
            // this.eventsService.publish(Constants.EVENT_TEST_SMS, JSON.stringify(data));
            this.eventsService.publish(Constants.EVENT_TEST_SMS, data);

            // const response = await this.firebaseFunctionsService.sendAllAboardTextMessage(contacts, this.vm.textMessage);
            // const response = await this.firebaseFunctionsService.sendFeedbackEmail('This is the subject', 'This is the body');
            await this.uxHelperService.hideSpinner();
            await this.uxHelperService.showToast('Text message sent.');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }
}
